<template>
  <div class="header-wrap">
    <a class="left-logo" href="javascript:;">
      <div class="pull-left header-logo"></div>
      <div class="pull-left logo-content">智慧调解</div>
    </a>
    <div class="title-name"></div>
    <div class="today-state">
      <div class="pull-left today-day">{{day}}</div>
      <div class="pull-left today-time">{{time}}</div>
      <div class="pull-left today-week">{{week}}</div>
      <div class="pull-left today-weather">{{currentWeather}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { AMapManager } from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';

export default {
  components: {
  },
  name: "headerVue",
  data() {
    return {
      weatherObj: null,
      currentWeather: '',
      day: '',
      time: '',
      week: ''
    }
  },
  methods: {
    ...mapActions([])
  },
  watch: {
  },
  computed: {
    ...mapGetters([])
  },
  created() {
    let that = this;
    lazyAMapApiLoaderInstance.load().then(() => {
      AMap.plugin('AMap.Weather', function () {
        let weather = new AMap.Weather();
        weather.getLive('上海市', function (err, data) {
          that.currentWeather = data.weather;
        });
        setInterval(() => {
          weather.getLive('上海市', function (err, data) {
            that.currentWeather = data.weather;
          });
        }, 60000);
      })
    });
    let date = new Date();
    this.day = date.getFullYear() + '-' + setTime(date.getMonth() + 1) + '-' + setTime(date.getDate());
    this.time = date.getHours() + ':' + setTime(date.getMinutes()) + ':' + setTime(date.getSeconds());
    function setTime(num) {
      if (num < 10) {
        num = '0' + num;
      }
      return num;
    }
    function setweek(weekNum) {
      let week = ''
      switch (date.getDay()) {
        case 0:
          week = '星期天'
          break;
        case 1:
          week = '星期一'
          break;
        case 2:
          week = '星期二'
          break;
        case 3:
          week = '星期三'
          break;
        case 4:
          week = '星期四'
          break;
        case 5:
          week = '星期五'
          break;
        case 6:
          week = '星期六'
          break;
      }
      return week;
    }
    this.week = setweek(date.getDay());
    setInterval(() => {
      let date = new Date();
      this.time = date.getHours() + ':' + setTime(date.getMinutes()) + ':' + setTime(date.getSeconds());
      if(this.time === '00:00:00') {
        this.week = setweek(date.getDay());
        this.day = date.getFullYear() + '-' + setTime(date.getMonth() + 1) + '-' + setTime(date.getDate());
      }
    }, 1000);
  },
  mounted() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../assets/scss/common.scss";
.header-wrap {
  position: relative;
  width: 100%;
  height: 80px;
  background: linear-gradient(to top, #042c4a, #001f3e, #001f3e, #042c4a);
  .title-name {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 1242px;
    height: 80px;
    background: url("../../public/images/index_title.png") no-repeat
      center/cover;
    z-index: 2;
  }
  .left-logo {
    position: absolute;
    left: 0;
    top: 0;
    padding-left: 20px;
    line-height: 80px;
    color: $white;
    font-size: 24px;
  }
  .header-logo {
    width: 33px;
    height: 80px;
    background: url("../../public/images/header-logo.png") no-repeat
      center/contain;
  }
  .logo-content {
    padding-left: 13px;
  }
  .today-state {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 80px;
    color: $white;
    font-size: 16px;
  }
  .today-day {
    padding-right: 20px;
  }
  .today-time {
    padding-right: 15px;
  }
  .today-week {
    padding-right: 20px;
  }
  .today-weather {
    padding-right: 20px;
  }
}
</style>